import { render } from "./RecentMv.vue?vue&type=template&id=2521fd72&scoped=true"
import script from "./RecentMv.vue?vue&type=script&lang=js"
export * from "./RecentMv.vue?vue&type=script&lang=js"

import "./RecentMv.vue?vue&type=style&index=0&id=2521fd72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2521fd72"]])

export default __exports__